enum MobileAppActionEnum {
  SHARE = 'share',
  COPY_LINK = 'copyLink',
  OPEN_LINK = 'openLink',
}

export { MobileAppActionEnum };
